export default class EventError {
  id: string;

  eventDate: Date;

  errorContext: string;

  status: string;

  eventId!: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.eventDate = obj.eventDate || '';
    this.errorContext = obj.errorContext || '';
    this.status = obj.status || '';
    if (obj && obj.event) {
      this.eventId = obj.event.id || '';
    }
  }

  public static of(value: any): EventError {
    return new EventError(value || {});
  }

  public static ofList(response: any): EventError[] {
    return response.data.map((event: any) => this.of(event));
  }
}
